(function($) {

    const toShow = 4;
    const slides = $('.productGallery__images_nav__items').find('.slide').length / 2;
    var centerSlides = true;
    
    if (slides < toShow) {
      centerSlides = false;
    } 

  $('.productGallery__images__items').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 50,
      arrows: false,
      fade: true,
      draggable: false,
      asNavFor: '.productGallery__images_nav__items',
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: true,
            prevArrow:' <button type="button" class="slick-prev productGallery__btns--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" fill="inherit"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next productGallery__btns--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" fill="inherit"/></svg></button>',
          }
        }
      ]
  });

  $('.productGallery__images_nav__items').slick({
      slidesToShow: toShow,
      speed: 100,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:' <button type="button" class="slick-prev productGallery__btns--next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" fill="inherit"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next productGallery__btns--prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" fill="inherit"/></svg></button>',
      infinity: true,
      asNavFor: '.productGallery__images__items',
      centerMode: centerSlides,
      centerPadding: '0',
      focusOnSelect: true
  });

})(jQuery);
